import Vue from 'vue'
import VueRouter from 'vue-router'

// HOME
Vue.transition('home', {
  css: false,
  enter: function (el, done) {
    $(el)
      .css('opacity', 0)
      .delay(500).animate({ opacity: 1 }, 350, done)
  },
  enterCancelled: function (el) {
    $(el).stop()
  },
  leave: function (el, done) {
    $(el)
      .css('opacity', 1)
      .animate({ opacity: 0 }, 1500, done)
  },
  leaveCancelled: function (el) {
    $(el).stop()
  }
})

// HOME
Vue.transition('nav', {
  css: false,
  enter: function (el, done) {
    $(el)
      .css('opacity', 0)
      .animate({ opacity: 1 }, 1500, done)
  },
  enterCancelled: function (el) {
    $(el).stop()
  },
  leave: function (el, done) {
    $(el)
      .delay(500).animate({ opacity: 0 }, 1250, done)
  },
  leaveCancelled: function (el) {
    $(el).stop()
  }
})

// TARGET TRANSITION
Vue.transition('target', {
  css: false,
  enter: function (el, done) {
    $(el)
      .css('opacity', 0)
      .delay(50).animate({ opacity: 1 }, 50, done)
    $('#body-content')
      .css('opacity', 0)
    $('#big-title')
      .css('left', "101vw")
      .delay(350).animate({ left: "-601vw" }, 350, done)
    $('.landing-video , .back-bar, .forward-bar')
      .css('opacity', 0)
      .delay(900).animate({ opacity: 1 }, 1500, done)
    $('#body-content')
      .css('opacity', 0)
      .delay(1500).animate({ opacity: 1 }, 500, done)
  },
  enterCancelled: function (el) {
    $(el).stop()
  },
  leave: function (el, done) {
    $(el).animate({ opacity: 0 }, 1000, done)
  },
  leaveCancelled: function (el) {
    $(el).stop()
  }
})



/** WEBPACK FOOTER **
 ** ./public/_src/_app/transition.js
 **/